/*
 * Hub bg layer — fixed `login-bg.png` from assets/auth/. Sits at z:0
 * so the global top-edge scrim (z:1) and the hub content (z:2) layer
 * on top correctly. cover/center matches the BgLayer pattern.
 */

.bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-color: #14241a;
  background-size: cover;
  background-position: center;
}
